import {
  AcceptActionType,
  CrateAction,
  CrateActionType,
  IncreaseBottleToleranceActionType,
  InAssortmentActionType,
  isAcceptActionType,
  isAcceptRejectAllAction,
  isAllMinimumCrateItemsAction,
  isCrateRefundGroupAction,
  isInAssortmentActionType,
  isMinimumCrateItemsAction,
  isSuperGroupAction,
} from '../../../domain/Assortment'
import { CrateGroup, Modification } from '../../../domain/DTO'

type ActionMap = {
  [key: string]: CrateAction
}

export const calculateFinalStatus = (
  original: CrateGroup,
  common: { [key: string]: CrateAction },
  override: { [key: string]: CrateAction | undefined },
  staged: { [key: string]: CrateAction | undefined },
) => {
  const acceptedAction =
    staged[acceptActionId(original.id)] ?? override[acceptActionId(original.id)] ?? common[acceptActionId(original.id)]
  const inAssortmentAction =
    staged[inAssortmentActionId(original.id)] ??
    override[inAssortmentActionId(original.id)] ??
    common[inAssortmentActionId(original.id)]

  const accepted =
    (original.accepted && acceptedAction?.type !== AcceptActionType.CLEAR) ||
    (!original.accepted && acceptedAction?.type === AcceptActionType.SET)
  const inAssortment =
    (original.inAssortment && inAssortmentAction?.type !== InAssortmentActionType.CLEAR) ||
    (!original.inAssortment && inAssortmentAction?.type === InAssortmentActionType.SET)

  return accepted && inAssortment
}

export const createCrateActions = (modifications: Modification[]): ActionMap => {
  return modifications.reduce((actions: ActionMap, modification) => {
    const actionType = modification.actionType
    if (actionType) {
      if (isAcceptActionType(actionType)) {
        actions[acceptActionId(modification.referenceObjectId)] = {
          type: actionType as CrateActionType,
          allowOverride: modification.allowedOverride,
        }
      } else if (isInAssortmentActionType(actionType)) {
        actions[inAssortmentActionId(modification.referenceObjectId)] = {
          type: actionType as CrateActionType,
          allowOverride: modification.allowedOverride,
        }
      } else if (isCrateRefundGroupAction(actionType)) {
        actions[refundGroupActionId(modification.referenceObjectId)] = {
          type: actionType as CrateActionType,
          allowOverride: modification.allowedOverride,
          value: modification.actionValue,
        }
      } else if (isMinimumCrateItemsAction(actionType)) {
        actions[minimumCrateItemsActionId(modification.referenceObjectId)] = {
          type: actionType as CrateActionType,
          allowOverride: modification.allowedOverride,
          value: modification.actionValue,
        }
      } else if (actionType === IncreaseBottleToleranceActionType.SET) {
        actions[increaseBottleToleranceActionId(modification.referenceObjectId)] = {
          type: actionType as CrateActionType,
          allowOverride: modification.allowedOverride,
          value: modification.actionValue,
        }
      } else if (isAllMinimumCrateItemsAction(actionType)) {
        actions[allMinimumCrateItemsActionId()] = {
          type: actionType as CrateActionType,
          allowOverride: modification.allowedOverride,
          value: modification.actionValue,
        }
      } else if (isAcceptRejectAllAction(actionType)) {
        actions[allAcceptOrRejectActionId()] = {
          type: actionType as CrateActionType,
          allowOverride: modification.allowedOverride,
          value: modification.actionValue,
        }
      } else if (isSuperGroupAction(actionType)) {
        actions[superGroupActionId(modification.referenceObjectId)] = {
          type: actionType as CrateActionType,
          allowOverride: modification.allowedOverride,
          value: modification.actionValue,
        }
      }
    }
    return actions
  }, {} as ActionMap)
}

export const acceptActionId = (id: string) => id + '[ACCEPT]'
export const inAssortmentActionId = (id: string) => id + '[IN_ASSORTMENT]'
export const refundGroupActionId = (id: string) => id + '[REFUND_GROUP]'
export const minimumCrateItemsActionId = (id: string) => id + '[MINIMUM_NUMBER_OF_ITEMS]'
export const increaseBottleToleranceActionId = (id: string) => id + '[INCREASE_BOTTLE_TOLERANCE]'
export const allMinimumCrateItemsActionId = () => '[MINIMUM_NUMBER_OF_ITEMS_ALL]'
export const allAcceptOrRejectActionId = () => '[ACCEPT_OR_REJECT_ALL]'
export const superGroupActionId = (id: string) => id + '[SUPER_GROUP]'
